import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import more from 'highcharts/highcharts-more'

more(Highcharts)

const MeteoChart = ({ options, title }) => {
  return (
    <div className="notification is-white ">
      <div className="tag is-primary is-light is-medium has-text-weight-bold">
        {title}
      </div>
      <div>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </div>
    </div>
  )
}

export default MeteoChart
